import { ArrowBack, OpenInNew } from '@mui/icons-material'
import { Box, Button, Stack, Typography } from '@mui/material'
import { ResourcesList } from './ProfessionalDevelopmentResource/ResourcesList'

interface Props {
  priorityId: number
  readOnly: boolean
  trackingReadonly: boolean
  onBack: () => void
  implementationPhase: boolean
  handleViewContract?: () => void
}

export const OtherProfessionalDevelopmentResources = (props: Props): JSX.Element => {
  return <Box data-testid='otherProfessionalDevelopmentResources' sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    position: 'relative'
  }}
  >
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Button
        data-testid="backPdrsButton"
        onClick={props.onBack}
        sx={{
          padding: '5px 10px',
          backgroundColor: 'var(--grey-50)',
          color: 'var(--grey-500)',
          width: 'fit-content',
          textTransform: 'none'
        }}
      >
        <ArrowBack sx={{ mr: '10px' }} />
        Professional Learning
      </Button>

      {props.implementationPhase && (
        <Button
          data-testid="viewContractButton"
          sx={{
            padding: '5px 10px',
            backgroundColor: 'var(--grey-50)',
            color: 'var(--grey-500)',
            width: 'fit-content',
            textTransform: 'none'
          }}
          onClick={props.handleViewContract}
        >
          View Contract
          <OpenInNew fontSize='small' sx={{ ml: '10px' }} />
        </Button>
      )}
    </Stack>

    <Typography variant='h1'>Other Professional Learning Resources</Typography>
    <Typography variant='body1'>
      List other professional learning resources that your ISD will need in the table below.
      Refer to the <a style={{ color: 'currentcolor' }} target='_blank' href='https://docs.google.com/document/d/1Ojt5fxeKvvCot5mERZaGGqihSdYFdoMw422SDIQkyFM/edit?tab=t.0'>RCN Contract Spending Guidelines</a> for guidance on the allowable use of RCN Contract funds.
    </Typography>

    <ResourcesList
      priorityId={props.priorityId}
      readOnly={props.readOnly}
      trackingReadonly={props.trackingReadonly}
      implementationPhase={props.implementationPhase}
    />
  </Box>
}
